import BaseClass from "../BaseClass.js";

export default class ClickedReactionHandler extends BaseClass {
    constructor(element) {
        super(element);
        this.reactionClickListener = null;
        this.contentId = null;
        this.conversationId = null;
        this.clickedReaction = null;
        this.eventName = 'reaction:clicked';
        this.init();
    }

    init() {
        let mySelf = this;

        const contentId = this.$element.attr("data-content-id");
        if (contentId != undefined) {
            this.contentId = contentId;
        }

        const conversationId = this.$element.attr("data-conv-id");
        if (conversationId != undefined) {
            this.conversationId = conversationId;
        }

        const chatType = this.$element.attr('type');
        if (chatType != undefined && chatType == 'camchat') {
            this.eventName = 'camchat:reaction:clicked';
        }

        let $clickedReaction = this.$element.find('[data-type="reaction-content"]');
        if ($clickedReaction.text() != undefined) {
            this.clickedReaction = $clickedReaction.text();
        }

        this.reactionClickListener = function (event) {
            if (mySelf.contentId != null) {
                const enhancedEvent = {
                    originalEvent: event,
                    contentId: mySelf.contentId,
                    clickedReaction: mySelf.clickedReaction,
                    conversationId: mySelf.conversationId,
                };

                $(document).trigger(mySelf.eventName, enhancedEvent);
            }
        }

        this.$element.on('click', this.reactionClickListener);
    }

    destroyListener() {
        this.$element.off('click', this.reactionClickListener);
    }
}